import React, { useEffect, useRef, useState } from 'react';

const BASE_WIDTH = 1100;
const MIN_SCALE = 0.7;

const DocumentPreviewScaler = ({ children, className = '' }) => {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const element = containerRef.current;
    if (!element || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const updateScale = () => {
      const width = element.clientWidth || BASE_WIDTH;
      const nextScale = Math.min(1, Math.max(MIN_SCALE, (width - 24) / BASE_WIDTH));
      setScale(nextScale);
    };

    updateScale();

    const observer = new ResizeObserver(() => {
      updateScale();
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className={`w-full ${className}`}>
      <div style={{ zoom: scale, width: '100%' }}>
        {children}
      </div>
    </div>
  );
};

export default DocumentPreviewScaler;
